export const CONFTYPE_DELETE_RESET = 'CONFTYPE_DELETE_RESET'
export const CONFTYPE_DELETE_SET_ERROR = 'CONFTYPE_DELETE_SET_ERROR'
export const CONFTYPE_DELETE_SET_DELETED = 'CONFTYPE_DELETE_SET_DELETED'
export const CONFTYPE_DELETE_TOGGLE_LOADING = 'CONFTYPE_DELETE_TOGGLE_LOADING'
